import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private isCollapsedSource = new BehaviorSubject<boolean>(true);
  isCollapsed$ = this.isCollapsedSource.asObservable();

  toggleSidebar() {
    this.isCollapsedSource.next(!this.isCollapsedSource.value);
  }

  setSidebarState(state: boolean) {
    this.isCollapsedSource.next(state);
  }
}
